/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type UserReportGrid_reports = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserReportGrid_reports",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "WidgetTypeRouter_reports",
      "args": null
    }
  ],
  "type": "ReportConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/__generated__/UserReportGrid_reports.graphql.js